<style lang="scss">
  @import '../resources/scss/menu_item.scss';
</style>

<script lang="ts">
  import NavLink from './NavLink.svelte'
  import { Constants } from '../config/constants'
  import { routes } from '../stores/stores'
  import type Menu from '../api/rest/directus-cms/menus/model/Menu'
  import type MenuTranslation from '../api/rest/directus-cms/menus/model/MenusTranslation'
  import type { APIMenusTranslation } from '../api/rest/directus-cms/common/collections/model/menus/APIMenusTranslation'
  import { useLocation } from 'svelte-navigator'
  import { locale } from 'svelte-i18n'
  import { fallbackLocale } from '../services/i18n'
  import { Slugs } from '../config/slugs'
  const location = useLocation()
  export let menu: Menu
  export let lang: string
  export let main = false
  export let homepage = false
  export let mobile = false

  let active = false

  $: lang = $locale ?? lang
  let category: MenuTranslation
  $: {
    const newCategory = (menu.translations ?? []).find(t => t.languages_id?.lang === lang)
    if (newCategory) category = newCategory
  }
  let c: APIMenusTranslation
  let categoryHref: string | undefined
  $: categoryHref =
    $routes.get(`${lang}${Constants.DOUBLE_BARS}${menu.slug}`) ??
    (menu.translations ?? [])?.find(
      translation => translation.languages_id?.lang === lang
    )?.link
  let selected: boolean
  $: {
    if (categoryHref) {
      selected =
        // selected when on the homepage as well
        (homepage && ($location.pathname === '/' || $location.pathname === `/${lang}`)) ||
        $location.pathname === categoryHref ||
        $location.pathname.startsWith(categoryHref + Constants.SLASH) ||
        // :FALLBACK: routes
        (lang === fallbackLocale &&
          $location.pathname.startsWith(categoryHref.replace(`/${lang}`, '')))
    } else selected = false
  }

  function getTranslatedSubName(d: Menu, l: string) {
    if (d.translations) {
      c = d.translations.find(t => t.languages_id!.lang === l)!
      return c.name
    } else return ''
  }
  function getTranslatedSlug(menu: Menu) {
    let slug = menu.slug ? menu.slug : ''
    return slug
  }
</script>

<div
  class="menu-container {menu.color_class} d-flex position-relative"
  class:main-menu-container={main}
  class:mobile
>
  <li class="menu-link" on:click={() => (active = !active)}>
    <NavLink
      ref={!menu.is_route
        ? undefined
        : mobile && menu.submenus.length > 0 && menu.slug == Slugs.Projects
        ? undefined
        : categoryHref}
      name={category.name}
      isIcon={false}
      color={menu.color_class}
      {main}
      {mobile}
      submenusShown={menu.submenus.length > 0 ? active : undefined}
      slug={menu.slug}
      notDropdown={menu.slug != Slugs.Projects}
      active={selected}
      external={!menu.internal_link}
    />
    {#if selected && main}<div class="selected-bar" class:mobile />{/if}
  </li>
  {#if menu.submenus.length > 0 && (!mobile || active) && (!mobile || menu.slug == Slugs.Projects)}
    <ul
      class="dropdown-menu {menu.color_class} {!mobile
        ? 'desktop'
        : ''} px-2 header-menus mt-0"
    >
      {#each menu.submenus as sub}
        <li class="submenus my-0">
          <NavLink
            color={menu.color_class}
            {main}
            active={selected}
            notDropdown={true}
            submenuLink={true}
            name={getTranslatedSubName(sub, lang)}
            ref={$routes.get(`${lang}${Constants.DOUBLE_BARS}${getTranslatedSlug(sub)}`)}
          />
        </li>
      {/each}
    </ul>
  {/if}
</div>
